var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.04 22.5a1.77 1.77 0 01-1.29-.52L.5 16.61A1.754 1.754 0 013 14.15l4 4.11L24.5.52A1.754 1.754 0 0127 2.98l-18.71 19a1.77 1.77 0 01-1.25.52z"}));
}

Tick.defaultProps = {"className":"fill-current","viewBox":"0 0 27.5 22.5"};

module.exports = Tick;

Tick.default = Tick;
